// Quick & dirty toggle to demonstrate modal toggle behavior
$('.start-modal-toggle').on('click', function(e) {
  e.preventDefault();
  $('.start-modal').toggleClass('is-visible');
});

$('.start-modal-toggle').click(function(){
   //Add class to body
   $("body").addClass("modal-toggle");
});
jQuery(document).ready(function(){

if(window.innerWidth < 768){
jQuery(document).scroll(function() {
var vids = document.querySelectorAll('video-media video');
    for(var i = 1;i < vids.length; i++){
vids[i].pause()
    }
});   

}
function redirectToCheckout(){
  var cc = 0; var timercc = setInterval(function(){
if($('cart-notification-drawer.quick-buy-drawer.drawer.show-close-cursor').length){
   window.location.href = "/checkout";
clearInterval(timercc);}if( cc > 200){clearInterval(timercc);}cc++;}, 50); 
}  

  
$('.buy-buttons.buy-buttons.buy-buttons--multiple > button').click(function(){
   redirectToCheckout()
}); 

$('.recurpay__action button').click(function(){
  redirectToCheckout()
});   
});


